export const calculateTotalPosts = (data) => {
  // Sum up all posts across the provided data
  return data.reduce((sum, item) => sum + (item.posts?.length || 0), 0);
};

export const calculateTotalReactions = (data) => {
  // Sum up likes and comments for all posts
  return data.reduce(
    (sum, item) =>
      sum +
      (item.posts?.reduce(
        (postSum, post) =>
          postSum +
          (post.postMetrics?.likes || 0) +
          (post.postMetrics?.comments || 0),
        0
      ) || 0),
    0
  );
};

// [NEW] Metrics
export const calculateTotalImpressions = () => 0;
export const calculateTotalReach = () => 0;
export const calculateTotalVideoViews = () => 0;
export const calculateTotalProfileViews = () => 0;
